// Module
var code = `
<template>
    <div class="comp-theme-picker">

        <comp-icon class="icon-color-palette" icon="color-palette" width="40" heigth="40"></comp-icon>
    </div>
</template>`;
// Exports
export default code;